var $ = require('jquery');
$('.yearslider-for').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	fade: true,
	adaptiveHeight: true,
	asNavFor: '.yearslider-nav'
  });
  $('.yearslider-nav').slick({
	slidesToShow:9,
	slidesToScroll: 1,
	asNavFor: '.yearslider-for',
	dots: false,
	 arrows: true,
	 adaptiveHeight: true,
	focusOnSelect: true,
	infinite: false ,
	responsive: [
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 4,
				slidesToScroll: 1,
				arrows: true
			}
		},
	]
  });
 
  $('a[data-slide]').click(function(e) {
	e.preventDefault();
	var slideno = $(this).data('slide');
	$('.yearslider-nav').slick('slickGoTo', slideno - 1);
  });


  $(window).on("load", function () {
	if ($(window).width() < 767){
	$('.yearslick').slick('refresh');
		
	}
});

$('.yearslider-nav').slick({
	arrows:false,
});